import React, { useState, useEffect } from 'react';
import db from './firebase';
import { collection, getDocs, query, where} from 'firebase/firestore';
import './App.css';

const App = () => {
  const [titles, setTitles] = useState([]);
  const [isTitles, setIsTitles] = useState(false);
  const [selectedSong, setSelectedSong] = useState('');
  const [lyric, setLyric] = useState(null);
  const [lyric2, setLyric2] = useState('');
  const [selectedWords, setSelectedWords] = useState('');
  const [showAnser, setShowAnser] = useState(true);
  const [creator, setCreator] = useState('');
  const [row, setRow] = useState(0);

  const loadAllSongTitle = (artist) => {
    const lyrics = collection(db, 'Lyrics');
    const songs = query(lyrics, where("artist", "==", "Mr.Children"));
    getDocs(songs).then((snapShot) => {
      let songTitles = [];
      snapShot.forEach((doc) => {
        const song = doc.data().song;
        songTitles.push(song);
      })
      setTitles(songTitles);
    })
  }

  const loadLyrics = () => {
    setShowAnser(false)
    const titleLength = titles.length;
    const randomNumber = Math.floor(Math.random()*titleLength);
    console.log(titles[randomNumber]);
    const selectedSong = titles[randomNumber]
    setSelectedSong(selectedSong);
    const lyrics = collection(db, 'Lyrics');
    const lyric = query(lyrics, where("song", "==", selectedSong));
    getDocs(lyric).then((snapShot) => {
      let lyrics = [];
      let creators = [];
      snapShot.forEach((doc) => {
        lyrics.push(doc.data().lyric)
        const creatorText = '作詞：'+ doc.data().lyricist + ' 作曲：' + doc.data().composer;
        creators.push(creatorText);
      })
      const lyric2 = lyrics[0];
      setLyric2(lyric2);
      selectWords(lyric2, 10);
      setCreator(creators[0]);
      const newTitles = titles.filter(item => item !== selectedSong);
      setTitles(newTitles);
    })
  }

  const hint = (lyric, n) => {
    let l = lyric.split('\n');
    let len = l.length;
    if (l[n].length !== 0 && n < len){
      setSelectedWords(l[n]);
      setRow(n);
    } else if (l[n].length == 0 && n < len) {
      setSelectedWords(l[n+1]);
      setRow(n+1);
    } else {
      setSelectedWords(l[n]);
      setRow(n);
    }
  } 

  const selectWords = (lyric, len) => {
    let l = lyric.split('\n');
      const l2 = l.length;
      const randomPhrase = Math.floor(Math.random()*(l2));
      let selectedPhrase = '';
      let n = 0;
      if (l[randomPhrase].length !== 0){
        selectedPhrase = l[randomPhrase];
        n = randomPhrase;
      } else {
        selectedPhrase = l[randomPhrase-1];
        n = randomPhrase-1;
        console.log('n-1');
      }
      setRow(n);
      const l3 = selectedPhrase.length;
      if (l3 > len) {
        const randomText = Math.floor(Math.random()*(l3-len));
        const selected = selectedPhrase.substr(randomText, len);
        setSelectedWords(selected);
        showLyric(lyric, n);
      } else {
        setSelectedWords(selectedPhrase);
        showLyric(lyric, n);
      }
  }

  const showLyric = (lyric, n) => {
    let l = lyric;
    const l2 = l.split('\n').map((item, index) => {
      if (index === n ){
        return (
          <React.Fragment><div className="textBlue">{item}<br/></div></React.Fragment>
        );
      } else {
        return (
          <React.Fragment><div>{item}<br/></div></React.Fragment>
        );       
      }
    })
    setLyric(l2);
  }


  useEffect(() => {
    loadAllSongTitle('Mr.Children');
  }, []);

  useEffect(() => {
    if (titles.length !== 0){
      setIsTitles(true);
    }
  }, [titles]);

  

  return (
    <div className="App">
      <h2>歌詞クイズ</h2>
      <p>Mr.Children</p>
      <p className="textSelect">{selectedWords}</p>
      {showAnser ? (
        <div>
        <button className="button" disabled={!isTitles} onClick={() => {loadLyrics()}}>次の曲</button>
        <h2>{selectedSong}</h2>
        <h4>{creator}</h4>
        <p>{lyric}</p>
        </div>
      ): (
        <div>
        <div>
        <button className="button" disabled={!isTitles} onClick={() => {setShowAnser(true)}}>正解は</button>
        </div>
        <div>
        <button className="hintbutton" disabled={!isTitles} onClick={() => {hint(lyric2, 0)}}>hint<br/>歌い出し</button>
        <button className="hintbutton" disabled={!isTitles} onClick={() => {hint(lyric2, row+1)}}>hint<br/>直後フレーズ</button>
        </div>
        </div>
      )}
    </div>
  );
}

export default App;
